// extracted by mini-css-extract-plugin
module.exports = {"DetailsBoxDesktop":"DetailsBox_DetailsBoxDesktop__Atrm3","DetailsBoxMobile":"DetailsBox_DetailsBoxMobile__1pFUv"};